<app-toast></app-toast>
<app-spinner></app-spinner>
<!-- `data-iframe-size`: faz o iframe-resizer medir a altura pela base deste
     bloco em vez de `document.documentElement`. A medição pelo <html> nunca
     fica menor que a altura atual do iframe, então, depois que ele cresce (por
     exemplo, com a tela cheia do PDF), ficaria travado no tamanho maior. -->
<div class="container-fluid" data-iframe-size>
  <div class="row">
    <main class="col-md-12 ms-sm-auto">
      <router-outlet></router-outlet>
    </main>
  </div>
</div>
